__webpack_require__.p = "/GPA-Calculator-using-ReactJS/";